/* eslint-disable react/jsx-props-no-spreading */
import React, { ChangeEvent, FocusEvent } from 'react';

type InputType =
  | 'text'
  | 'email'
  | 'url'
  | 'password'
  | 'number'
  | 'search'
  | 'date'
  | 'tel';

type InputProps = {
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  error?: boolean;
  type?: InputType;
  [x: string]: any;
};

function Input({
  className,
  type,
  name,
  error,
  onChange,
  ...props
}: InputProps) {
  return (
    <input
      {...props}
      className={`${className} ${
        error ? '!border-pos-red' : ''
      } disabled:border-[#dfe5eb] disabled:bg-[#f5f7fa] disabled:text-opacity-50`}
      name={name}
      type={type}
      aria-label={name}
      onChange={onChange}
    />
  );
}

Input.defaultProps = {
  className: '',
  type: 'text',
  error: false,
  onChange: undefined,
};

export default Input;
